import React, { useEffect, useState, useMemo, useRef } from 'react';
import { Container, FakePlate, Header, Plate, Row, SubHeader } from 'features/shared/ui/Page';
import UnauthorizedLayout from 'features/shared/layouts/unauthorized';
import SwitchTabs, { SwitchTabsType } from 'features/shared/SwitchTabs';
import styled from 'styled-components';
import { OlympiadsApi } from 'api';
import { Api } from 'api/cabmun-api-public';
import OlympiadDetailsUi from 'features/olympiads/components/OlympiadDetails/OlympiadDetailsUi';
import { Space } from '@gr-monorepo/common/ui';
import DownloadOlympiadSchedule from 'features/olympiads/components/DownloadOlympiadSchedule';
import { OlympiadStatus } from 'features/olympiads/model';
import { UnauthPlateText } from 'features/shared/UnauthPlateText';

export const TextColumn = styled.div`
  flex: 0 0 auto;
  letter-spacing: -0.2px;
`;
export const NoOlympiads = styled.div`
  margin: 85px 0;
  font-weight: bold;
  font-size: 20px;
  line-height: 28px;
  color: rgba(9, 21, 38, 0.6);
`;
export const Text = styled.div`
  font-size: 16px;
  line-height: 22px;
  color: rgba(9, 21, 38, 0.6);
  display: flex;
  padding: 24px 24px 40px;
`;

const yearSwitcherValues = [{ id: '2025-2026', label: '2025-2026' }];

const values = [
  { id: 'current', label: 'Проводятся сейчас' },
  { id: 'future', label: 'Будут проведены' },
];

const Olympiads = () => {
  const [loaded, setLoaded] = useState(false);
  const [olympiads, setOlympiads] = useState<Api.GetUnAuthOlympiads200Response[]>([]);
  const [selectedStatus, setSelectedStatus] = useState(values[0]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await OlympiadsApi.getUnAuthOlympiads();
        setOlympiads(result?.map((el) => ({ ...el, url: `${el.url?.replaceAll('{{cabmun_id}}', '0')}` })) || []);
      } catch (e) {}
      setLoaded(true);
    };
    fetchData();
  }, []);

  const filteredOlympiads = useMemo(
    () => olympiads.filter((el) => el.status === selectedStatus.id),
    [selectedStatus, olympiads],
  );

  return (
    <UnauthorizedLayout>
      <Container>
        <Header>Олимпиады</Header>
        <Text>
          <TextColumn style={{ width: 392 }}>
            Современные интерактивные соревнования повышают мотивацию учеников к&nbsp;изучению школьных предметов,
            развивают креативное мышление, логику и&nbsp;другие гибкие навыки.
            <br />
            <br />
            Олимпиады проходят в&nbsp;онлайне&nbsp;&mdash; участвовать может любой школьник. Это бесплатно.
          </TextColumn>
          <Space size={20} axis={'vertical'} />
          <TextColumn style={{ width: 392 }}>
            Ряд олимпиад входит в&nbsp;перечень Минпросвещения России и&nbsp;поддерживается национальными проектами.
            Партнёрами выступают АНО &laquo;Национальные приоритеты&raquo;, федеральные министерства, агентства
            и&nbsp;службы РФ, крупные технологические корпорации.
          </TextColumn>
        </Text>
        <Plate data-qa-id="olympiads_block">
          <>
            <SubHeader>Общая статистика</SubHeader>
            <Space size={24} axis={'vertical'} />
            <FakePlate style={{ padding: 100 }} data-qa-id="totals_statistics">
              <UnauthPlateText />
            </FakePlate>
            <Space size={40} axis={'vertical'} />
            <DownloadOlympiadSchedule yearLearn={yearSwitcherValues[0].id} />
            <Space size={40} axis={'vertical'} />
            <SwitchTabs
              values={values}
              value={selectedStatus}
              handleChange={(value) => setSelectedStatus(value)}
              type={SwitchTabsType.pills}
            />
            {loaded && !filteredOlympiads.length ? (
              <NoOlympiads>
                {selectedStatus.id === OlympiadStatus.current
                  ? 'Нет текущих Олимпиад'
                  : selectedStatus.id === OlympiadStatus.future
                  ? 'Нет будущих Олимпиад'
                  : 'Нет завершенных олимпиад'}
              </NoOlympiads>
            ) : null}
            {filteredOlympiads.map((el) => (
              <OlympiadDetailsUi
                data={el as any}
                showRating={false}
                status={el.status as OlympiadStatus}
                withoutParticipants={true}
              >
                {el.status !== 'future' && (
                  <FakePlate style={{ padding: '212px 0' }}>
                    <UnauthPlateText />
                  </FakePlate>
                )}
              </OlympiadDetailsUi>
            ))}
          </>
        </Plate>
      </Container>
    </UnauthorizedLayout>
  );
};

export default Olympiads;
